export default __webpack_public_path__ + "static/head-9ae4237574db3763fda745208ea7f79b.png";